export const NODE_TYPES = {
    TEXT_FIELD: 'TEXT_FIELD',
    DROPDOWN: 'DROPDOWN',
    CALENDAR: 'CALENDAR',
    RADIO: 'RADIO',
    CHECKBOX: 'CHECKBOX',
    TEXT_AREA: 'TEXT_AREA',
    RATING: 'RATING',
    IMAGELIST: 'IMAGELIST',
    DROPDOWN_TEXT_FIELD: 'DROPDOWN_TEXT_FIELD',
}

// all keys: ['inputMode', 'inputRegex', 'minSize', 'maxSize', 'filterKey']
export const EXCLUDE_FOR_SIDEBAR_IPTS = {
    [NODE_TYPES.TEXT_FIELD]: [],
    [NODE_TYPES.DROPDOWN]: ['inputMode', 'inputRegex'],
    [NODE_TYPES.CALENDAR]: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
    [NODE_TYPES.RADIO]: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
    [NODE_TYPES.CHECKBOX]: ['inputMode', 'inputRegex'],
    [NODE_TYPES.TEXT_AREA]: ['inputMode'],
    [NODE_TYPES.RATING]: ['inputMode', 'inputRegex'],
    [NODE_TYPES.IMAGELIST]: ['inputMode', 'inputRegex', 'minSize', 'maxSize'],
    [NODE_TYPES.DROPDOWN_TEXT_FIELD]: ['inputMode', 'inputRegex'],
}

export const KEYS_OF_WITHOUT_OPTIONS = [NODE_TYPES.TEXT_FIELD, NODE_TYPES.CALENDAR, NODE_TYPES.TEXT_AREA, NODE_TYPES.RATING, NODE_TYPES.IMAGELIST]

export const PREFIX_OF_TEMP_NODE = '7uvpnotl7po_'

export const KEYS_OF_IS_CREATE = 'create'

// Draft storage keys
export const KEYS_OF_DRAFT_DATA = 'survey_draft_data'
export const KEYS_OF_TEMP_DRAFT_DATA = 'survey_draft_temp'

export const KEYS_OF_FILTER_KEY_LIST = 'filterKeyList'

export const OPTIONS_TO_DISPLAY = 3